export const TOKEN = 'token'
export const EXPIRATION_TIME_TOKEN = 'expiration_time_token'
export const CORE_DOMAIN = 'core-domain'
export const JWT = 'jwt'
export const EXPIRATION_TIME_JWT = 'expiration_time_jwt'
